import React, { useEffect } from 'react';
import Message, { THEME } from '@mos-cat/message';
import { Trans } from '@lingui/macro';
import { createStructuredSelector } from 'reselect';
import { Heading } from '@mos-cat/typography';
import { Dispatch } from 'redux';
import { connect } from 'dva';

import {
  getSubsequentRequestError,
  isAddressSubsequentErrorVisible,
} from '../../../../selectors/addressUnmodeled';
import { AddressFields } from '../../../../../types/address';
import {
  addressSubsequentRequestError,
  sendStats,
} from '../../../../helpers/stats';
import './style.pcss';
import { EIRCRequestError } from '../../../../errors/EIRC';

interface StateProps {
  error: AddressFields['subsequentRequestError'];
  isVisible: boolean;
}

interface DispatchProps {
  retry(): void;
}

interface OwnProps {
  model: 'applicant' | 'spouse' | 'child';
  forManualInput?: boolean;
}

type Props = StateProps & DispatchProps & OwnProps;

function AddressSubsequentRequestError(props: Props): JSX.Element | null {
  const { isVisible, error } = props;
  useEffect(() => {
    if (isVisible)
      sendStats(
        addressSubsequentRequestError(
          error === EIRCRequestError.errorName ? 'eirc' : 'omk'
        )
      );
  }, [isVisible]);
  if (!isVisible) return null;
  return (
    <div className="PguFormGrid__row">
      <Message theme={THEME.DANGER} className="AddressMessage">
        <Heading level={5} className="AddressMessage__header">
          <Trans>Произошла ошибка при проверке адреса</Trans>
        </Heading>
        <Trans>
          Повторите попытку позже или{' '}
          <button
            type="button"
            className="MessageEirc__Button mos-link"
            onClick={props.retry}
          >
            попробуйте еще раз сейчас
          </button>
        </Trans>
      </Message>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  error: getSubsequentRequestError,
  isVisible: isAddressSubsequentErrorVisible,
});

function mapDispatchToProps(
  dispatch: Dispatch,
  { model }: OwnProps
): DispatchProps {
  return {
    retry() {
      dispatch({ type: `${model}/address/subsequentRequest/retry` });
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddressSubsequentRequestError);
